import React from 'react';
import { motion } from 'framer-motion';
interface PageTransitionProps {
  children: React.ReactNode;
}
// Crossfade with scale animation variants
const pageVariants = {
  initial: {
    opacity: 0,
    scale: 0.96
  },
  animate: {
    opacity: 1,
    scale: 1
  },
  exit: {
    opacity: 0,
    scale: 1.02
  }
};
const pageTransition = {
  type: 'tween',
  ease: 'easeInOut',
  duration: 0.3
};
export function PageTransition({
  children
}: PageTransitionProps) {
  return <motion.div initial="initial" animate="animate" exit="exit" variants={pageVariants} transition={pageTransition} style={{
    width: '100%',
    minHeight: '100vh'
  }} data-id="element-221">
      {children}
    </motion.div>;
}